<script setup lang="ts">
import { computed } from "vue";

import { toggleActions } from "@/action/toggleActions";
import { actionMap } from "@/components/action/action";
import MenuItemDelimiter from "@/components/menu/MenuItemDelimiter.vue";
import SearchIcon from "@/components/search/SearchIcon.vue";
import IconButton from "@/components/ui/IconButton/IconButton.vue";
import { isStickyBoard } from "@/model/board";
import { useBoardStore } from "@/store/board";
import { useUserStore } from "@/store/user";

import SwitchSessionItem from "./internal/SwitchSessionItem.vue";

const boardType = computed(() => useBoardStore().board?.type);
const showMetrics = computed(() => boardType.value === "program" || boardType.value === "team");
const hasStickies = computed(() => isStickyBoard(boardType.value));

const showIssueSelector = computed(
  () => boardType.value === "team" && useUserStore().isAllowed("edit"),
);

const actions = actionMap(toggleActions);
</script>

<template>
  <div>
    <SwitchSessionItem />

    <template v-if="hasStickies">
      <MenuItemDelimiter />
      <SearchIcon />
    </template>

    <template v-if="showIssueSelector">
      <MenuItemDelimiter />
      <IconButton v-bind="actions.toggleIssueSelector" aria-controls="issue-selector-panel" />
    </template>

    <template v-if="hasStickies">
      <MenuItemDelimiter />
      <IconButton v-bind="actions.toggleBoardHistory" />
    </template>

    <template v-if="showMetrics">
      <MenuItemDelimiter />
      <IconButton class="metrics-modal-trigger" v-bind="actions.showProgramMetrics" />
      <IconButton class="metrics-modal-trigger" v-bind="actions.showTeamMetrics" />
    </template>
  </div>
</template>
